<ng-container *transloco="let tToast; read: 'toast.autoTeamSwitch'">
  <span class="header">{{ tToast("header") }}</span>
  <div>
    {{ tToast("content-1") }}
    <span>{{ data.options?.data }}</span>
    {{ tToast("content-2") }}
  </div>
</ng-container>
